import { PageSection } from 'pricing-pages-ui-components/semantic/PageSection';
import { useGlobalLoading } from '../../hooks/loadingHooks';
import { useAppSelector } from '../../reducers';
import { highestProductLevelFromProductInventorySelector } from '../../selectors/ProductInventorySelectors';
import UnlockAIContentTabLayout from './UnlockAIContentTabLayout';
import UnlockAIContent from './UnlockAIContent';
import { jsx as _jsx } from "react/jsx-runtime";
const UnlockAISection = () => {
  const isAppReady = useGlobalLoading();
  const highestProductLevelOwned = useAppSelector(state => {
    if (!isAppReady) return null;
    return highestProductLevelFromProductInventorySelector(state);
  });
  const isFreeOrProspect = highestProductLevelOwned === 'FREE';
  return /*#__PURE__*/_jsx(PageSection, {
    children: isFreeOrProspect ? /*#__PURE__*/_jsx(UnlockAIContentTabLayout, {}) : /*#__PURE__*/_jsx(UnlockAIContent, {})
  });
};
export default UnlockAISection;